import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/11_poppies/11_poppies"
 * Contains 1 texture(s)
 */
export class Tablet11PoppiesAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/11_poppies/11_poppies';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '11_poppies.jpg'
    ] as const;
}
